import { render } from "./TodoCardShowPagamento.vue?vue&type=template&id=f8671b18"
import script from "./TodoCardShowPagamento.vue?vue&type=script&lang=js"
export * from "./TodoCardShowPagamento.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__